export class mdlStatus_DH {
    public StatusCode: string;
    public StatusDesc: string;
}


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Models/mdlStatus_DH.ts